import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from '../../@theme/pipes/dateFormatPicker';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'ngx-buscador',
  templateUrl: './buscador.component.html',
  styleUrls: ['./buscador.component.scss'],
  providers: [UtilidadesService, PeticionesHttpBackEndService, NgbModalConfig, NgbModal, { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }]
})
export class BuscadorComponent implements OnInit {

  Token: any;
  openModal: any;
  usuario: any;
  textoBusqueda: any;
  resultadosBusqueda: any;
  modelAvanzado: boolean;
  modelNombre: boolean;
  modelBio: boolean;
  modelMuro: boolean;
  modelForo: boolean;
  modelEtiquetaUser: boolean;
  modelEtiquetaMens: boolean;
  textoBusquedaTexto: any;
  textoBusquedaEtiquetas: any;
  parametrosUrl: any;
  constructor(private datepip: DatePipe, private _route: ActivatedRoute, private utilidades: UtilidadesService, config: NgbModalConfig, private modalService: NgbModal, private _http: PeticionesHttpBackEndService, private DatePipe: DatePipe, public fb: FormBuilder, private router: Router) {
    _route.queryParams.subscribe(params => {
      this.parametrosUrl = params || null;
      
    });
    this.Token = JSON.parse(localStorage.getItem('auth_app_token'));
    config.backdrop = 'static';
    config.keyboard = false;
    this.textoBusqueda = "";
    this.resultadosBusqueda = [];
    this.modelAvanzado = false;
    this.modelNombre = true;
    this.modelBio = true;
    this.modelMuro = true;
    this.modelForo = true;
    this.modelEtiquetaUser = true;
    this.modelEtiquetaMens = true;
    this.textoBusquedaTexto = "";
    this.textoBusquedaEtiquetas = "";
  }

  ngOnInit() {
    this._http.getUsuario().subscribe(
      result => {
        this.usuario = result;
        if(this.parametrosUrl.nom !== undefined && this.parametrosUrl.nom !== null){
          this.textoBusqueda = this.parametrosUrl.nom;
          this.buscar();
        }
      }
    );
  }

  navegarMuroFormativo(evento) {
    let parametros: NavigationExtras = {
      queryParams: { 'm': evento.MuroId }
    };
    this.router.navigate(['private/muro-grupo'], parametros);
  }

  buscar() {
    if (this.textoBusqueda.length > 2) {
      this.resultadosBusqueda = [];
      this._http.insertaObjecto("v1/buscadorSocial", {
        Data: {
          "entidadId": this.usuario.Entidad._entidad_id,
          "textoBuscar": this.textoBusqueda,
          "modelNombre": true,
          "modelBio": true,
          "modelMuro": false,
          "modelForo": false,
          "modelEtiquetaUser": true,
          "modelEtiquetaMens": true
        }
      }).subscribe(
        result => {
          let resultado: any = result;
          if (resultado.Code == 200) {
            this.resultadosBusqueda = resultado.ResultadosBusqueda;
          } else {
            this.utilidades.notificationWarning("Aviso", resultado.Mensaje, "top-left");
          }

        },
        error => {
        }
      );
    } else {
      this.utilidades.notificationWarning("Aviso", "Al menos debe de tener 3 caracteres", "top-left");
    }

  }
  buscarTexto() {
    if (this.textoBusquedaTexto.length > 2) {
      this.resultadosBusqueda = [];
      this._http.insertaObjecto("v1/buscadorSocial", {
        Data: {
          "entidadId": this.usuario.Entidad._entidad_id,
          "textoBuscar": this.textoBusquedaTexto,
          "modelNombre": this.modelNombre,
          "modelBio": this.modelBio,
          "modelMuro": this.modelMuro,
          "modelForo": this.modelForo,
          "modelEtiquetaUser": false,
          "modelEtiquetaMens": false
        }
      }).subscribe(
        result => {
          let resultado: any = result;
          if (resultado.Code == 200) {
            this.resultadosBusqueda = resultado.ResultadosBusqueda;
          } else {
            this.utilidades.notificationWarning("Aviso", resultado.Mensaje, "top-left");
          }

        },
        error => {
        }
      );
    } else {
      this.utilidades.notificationWarning("Aviso", "Al menos debe de tener 3 caracteres", "top-left");
    }
  }
  buscarEtiquetas() {
    if (this.textoBusquedaEtiquetas.length > 2) {
      this.resultadosBusqueda = [];
      this._http.insertaObjecto("v1/buscadorSocial", {
        Data: {
          "entidadId": this.usuario.Entidad._entidad_id,
          "textoBuscar": this.textoBusquedaEtiquetas,
          "modelNombre": false,
          "modelBio": false,
          "modelMuro": false,
          "modelForo": false,
          "modelEtiquetaUser": this.modelEtiquetaUser,
          "modelEtiquetaMens": this.modelEtiquetaMens
        }
      }).subscribe(
        result => {
          let resultado: any = result;
          if (resultado.Code == 200) {
            this.resultadosBusqueda = resultado.ResultadosBusqueda;
          } else {
            this.utilidades.notificationWarning("Aviso", resultado.Mensaje, "top-left");
          }

        },
        error => {
        }
      );
    } else {
      this.utilidades.notificationWarning("Aviso", "Al menos debe de tener 3 caracteres", "top-left");
    }
  }

  verMuro(evento) {
    if (evento.EsPerfil == 1) {
      let parametros: NavigationExtras = {
        queryParams: { 'uM': evento.EntidadId }
      };
      this.router.navigate(['private/muro-usuarios'], parametros);
    } else if (evento.EsPerfil == 0 && evento.EsMuro == 1) {
      if (evento.EntidadId !== undefined && evento.EntidadId !== 0) {
        let parametros: NavigationExtras = {
          queryParams: { 'uM': evento.EntidadId }
        };
        this.router.navigate(['private/muro-usuarios'], parametros);
      } else if (evento.Actividad !== undefined && evento.Actividad !== 0) {
        let parametros: NavigationExtras = {
          queryParams: { 'ac': evento.Actividad }
        };
        this.router.navigate(['private/muro-actividad'], parametros);
      } else if (evento.MurosParticipantes !== undefined && evento.MurosParticipantes !== 0) {
        let parametros: NavigationExtras = {
          queryParams: { 'm': evento.MurosParticipantes }
        };
        this.router.navigate(['private/muro-grupo'], parametros);
      }
    }
  }

  verForo(evento) {
    let parametros: NavigationExtras = {
      queryParams: {
        'tema': evento.ForoTemaId,
        'f': evento.MuroId
      }
    };
    this.router.navigate(['private/foros-mensajes'], parametros);
  }

  cambioAvanzado() {
    this.resultadosBusqueda = [];
    this.textoBusqueda = "";
    this.textoBusquedaTexto = "";
    this.textoBusquedaEtiquetas = "";
  }
}
